import { render, staticRenderFns } from "./SocialMediaSection.htm?vue&type=template&id=cddb008e&scoped=true&"
import script from "./SocialMediaSection.ts?vue&type=script&lang=js&"
export * from "./SocialMediaSection.ts?vue&type=script&lang=js&"
import style0 from "./SocialMediaSection.scss?vue&type=style&index=0&id=cddb008e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddb008e",
  null
  
)

export default component.exports